import React from 'react';
import { motion } from 'framer-motion';

/**
 * AnimatedPage Component
 * 
 * Wraps page content with smooth fade-in and slide-up animations.
 * Excludes Header and Footer - only animates main page content.
 */

// Define variants outside component to prevent re-creation
const pageVariants = {
  initial: {
    opacity: 0,
    y: 20
  },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.22, 1, 0.36, 1] // Custom easing for smooth feel
    }
  },
  exit: {
    opacity: 0,
    y: -20,
    transition: {
      duration: 0.4
    }
  }
};

const AnimatedPage = ({ children, className = "" }) => {
  return (
    <motion.div
      initial="initial"
      animate="animate"
      exit="exit"
      variants={pageVariants}
      className={className}
    >
      {children}
    </motion.div>
  );
};

export default AnimatedPage;
